











import {Component, Prop, Vue } from 'vue-property-decorator';
import EmojiType from '@/models/EmojiType';

@Component
export default class Board extends Vue {
  @Prop() private emojis!: EmojiType[];

  private prevEmoji!: EmojiType | null;

  public openEmoji(emoji: EmojiType): void {
    if (!emoji.matched && !emoji.opened) {
      emoji.opened = true;
      this.match(emoji);
    }
  }

  private match(emoji: EmojiType): void {
    setTimeout(() => {
      if (!this.prevEmoji) {
        this.prevEmoji = emoji;
      } else {
        if (this.prevEmoji.emoji === emoji.emoji) {
          this.prevEmoji.matched = emoji.matched = true;
        } else {
          this.prevEmoji.opened = emoji.opened = false;
        }
        this.prevEmoji = null;
      }
    }, 1000);
  }
}
